import {until} from 'lit-html/directives/until';

export default (ctx, html) => html`
<div class="row mx-4 info-row ${ctx.loading ? 'loading' : ''}">
    <div class="col-3 px-0 font-weight-bold">
      ${ctx.row.label ? ctx.row.label : until(ctx._r(ctx.__('<tt-TN2m6CLH>', '%r1% Licenses:'), ctx.row.groupName))}
    </div>
    <div class="col-xs-2 col-xl-3 py-2 text-center">
      <div>${until(ctx.__('<tt-QlK/M3nV>', 'Total'))}</div>
      <div class="font-weight-bold">${ctx.row.total}</div>
    </div>
    <div class="col-xs-2 col-xl-3 py-2 text-center border-dashed-left text-nowrap">
      <div>${until(ctx.__('<tt-bN+X8BYA>', 'Available'))}</div>
      <div class="font-weight-bold">${ctx.row.unassigned}</div>
    </div>
    <div class="col-xs-5 col-xl-3 row">
      <div class="col-6 py-2 text-right border-dashed-left text-nowrap">
        <div>${until(ctx.__('<tt-psBcenYn>', 'Assigned'))}</div>
        <div class="font-weight-bold">${ctx.row.assigned}</div>
      </div>
      <div class="col-6">
        <div class="d-flex flex-column bg-light rounded-lg py-2 px-3 d-inline-flex text-nowrap">
          <div>${until(ctx.__('<tt-ClLqqEph>', 'Redeemed'))}</div>
          <div class="font-weight-bold">${ctx.row.redeemed}</div>
        </div>
      </div>
    </div>
</div>
`;
